import React, { Component } from 'react';
import Select from 'react-select';
import { Divider, Form, Segment, Button } from 'semantic-ui-react'
import * as UiConsts from '../../../../config/UiConstants';
import axios from 'axios'
import { serverIp, logDashboardAction } from '../../../../config/constants';
import * as FbUtils from '../../../../Utilities/FireBaseUtils';
import * as moment from 'moment';
import { algoliaPartialUpdateOrder } from '../algoliaDashboard/AlgoliaMiscUtils';



class Feedback extends Component {
    constructor(props) {
        super(props);
        this.state = {
            happyWith: '',
            orderAgain: '',
            recommend: '',
            improvement: '',
            happyWithChoices: [
                { value: 'yes', label: 'yes', category: 'happyWith' },
                { value: 'no', label: 'no', category: 'happyWith' },
            ],
            orderAgainChoices: [
                { value: 'yes', label: 'yes', category: 'orderAgain' },
                { value: 'no', label: 'no', category: 'orderAgain' },
            ],
            recommendChoices: [
                { value: 'yes', label: 'yes', category: 'recommend' },
                { value: 'no', label: 'no', category: 'recommend' },
            ],
        }
    }

    handleOrderDetailsDropDownChanges = (value) => {
        console.log('fdbx1 You\'ve sss:', value);
        console.log('fdbx12 You\'ve selected:', value.value + " " + value.category);

        let newState = {};
        newState[value.category] = value.value;

        this.setState(newState);
    }

    handleChange = (e) => {
        console.log("fdbx13 >>>>: handleChange clicked");
        console.log("fdbx14 e.target.type:" + e.target.type);
        console.log("fdbx15 e.target.name:" + e.target.name);
        console.log("fdbx16 e.target.value:" + e.target.value);

        let newState = {};
        newState[e.target.name] = e.target.value;
        this.setState(newState);

    }

    setFeedback = () => {
        console.log("fdbx17 this.props.order.key:" + this.props.order.key);
        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdates = {

            feedback_lastUpdated: now,
            feedback_lastUpdatedBy: this.props.user.email,
            feedback_happyWith: this.state.happyWith,
            feedback_orderAgain: this.state.orderAgain,
            feedback_recommend: this.state.recommend,
            feedback_improvement: this.state.improvement,
        }

        if(this.props.order.archived || this.props.order.algoliaArchived){
            console.log("fdbx181 archived order this.props.order.archived || this.props.order.algoliaArchived")
            console.log("fdbx18 orderId this.props.order.key:" + this.props.orderId);

            orderUpdates.objectID = this.props.orderId;
            console.log("fdbx19 orderUpdates.objectID:"+orderUpdates.objectID);

            console.log("fdbx20 orderUpdates.objectID:"+JSON.stringify(orderUpdates,null,3));
            
            algoliaPartialUpdateOrder(orderUpdates);
        }else{
            FbUtils.updateOrder(this.props.order.key, orderUpdates);
        }

        
    }

    sendFeedback = () => {
        console.log("fdbx21 ======checkCoupon");

        if (this.state.happyWith == '') {
            alert("Pls select if they are happy with their order?");

        } else if (this.state.orderAgain == '') {
            alert("Pls select if they will order Again");

        } else if (this.state.improvement == '') {
            alert("Pls enter what we need to improve");

        } else if (this.state.recommend == '') {
            alert("Pls enter if they would recommend us");

        } else {
            this.setState({ loading: true })

            let data = {
                apiKey: "apikeyasd3377I",
                happyWith: this.state.happyWith,
                orderAgain: this.state.orderAgain,
                recommend: this.state.recommend,
                improvement: this.state.improvement,
                fbOrderKey: this.props.orderId,
            }

            console.log("fdbx22 data  to send:"+JSON.stringify(data,null,3));

            axios.post(serverIp + 'delivery/saveFeedback', {
                apiKey: "apikeyasd3377I",
                happyWith: this.state.happyWith,
                orderAgain: this.state.orderAgain,
                recommend: this.state.recommend,
                improvement: this.state.improvement,
                fbOrderKey: this.props.orderId,
            })
                .then((response) => {
                    this.setState({ loading: false })
                    console.log(response.data);

                    if (response.data.result) {
                        console.log("true.. feedback got back");

                        logDashboardAction(this.props.user.email + " entered feedback for "+this.props.order.order_num, this.props.user.email , this.props.order.order_num, "feedback");

                        this.setFeedback();
                        alert("SUCCESS! feedback SET");
                    } else {
                        console.log("FAILED");
                        alert("FAILED TO SET feedback:" + response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                    alert("FAILED TO SET feedback");
                });
        }

    }


    render() {

        const submitButton = this.state.happyWith != '' && this.state.recommend && this.state.orderAgain != '' && this.state.improvement != ''
            ? <Button color='red' > SUBMIT </Button>
            : ''


        return (this.state.loading ? <UiConsts.LoadingComponent /> : <div>
            <Divider horizontal>{'FEEDBACK'}</Divider>
            {/* QUICK SELECT STUFF */}

            <Form size='large' onSubmit={this.sendFeedback}>
                <Segment stacked>
                    <label>Did they get want they wanted?</label>
                    <Select
                        name="form-field-name"
                        value={this.state.happyWith}
                        options={this.state.happyWithChoices}
                        onChange={this.handleOrderDetailsDropDownChanges}
                        searchable={false}
                        clearable={false}
                    />

                    <label>Would they order with us again?</label>
                    <Select
                        name="form-field-name"
                        value={this.state.orderAgain}
                        options={this.state.orderAgainChoices}
                        onChange={this.handleOrderDetailsDropDownChanges}
                        searchable={false}
                        clearable={false}
                    />

                    <label>Would they recommend us?</label>
                    <Select
                        name="form-field-name"
                        value={this.state.recommend}
                        options={this.state.recommendChoices}
                        onChange={this.handleOrderDetailsDropDownChanges}
                        searchable={false}
                        clearable={false}
                    />
                    <Form.Input
                        fluid
                        icon='person'
                        iconPosition='left'
                        placeholder='Any improvement'
                        type='text'
                        name="improvement"
                        onChange={this.handleChange}
                    />
                    {submitButton}
                </Segment>

            </Form>

        </div>);
    }
}

export default Feedback;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Feedback/Feedback.js